import { useEffect } from 'react';
import { NextRouter } from 'next/router';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';

import AuthenticatedUser from '../useAuth/AuthenticatedUser';

import { AcceptanceDocumentPath } from '../../../main/acceptanceDocuments/AcceptanceDocumentPath';
import { AccountPath } from '../../../main/accounts/AccountPath';
import { AuthPath } from '../../AuthPath';
import { MainPath } from '../../../main/MainPath';

interface AuthRedirectsOptions {
  currentUser: AuthenticatedUser | null;
  router: NextRouter;
}

const allowedBlockedUrls = [AccountPath.paymentsBalanceSheet()];

export function useAuthRedirects({
  currentUser,
  router
}: AuthRedirectsOptions) {
  useEffect(() => {
    // Blocked users redirect
    if (
      currentUser?.blocked &&
      !currentUser?.client &&
      !includes(router.pathname, AuthPath.base()) &&
      !includes(router.pathname, AuthPath.registerShort()) &&
      !includes(allowedBlockedUrls, router.pathname)
    ) {
      void router.push(AccountPath.paymentsBalanceSheet());
    }

    // Terms update redirect
    const hasDocumentsToAccept = !isEmpty(currentUser?.documentsToAccept);

    if (
      currentUser?.needAcceptDocuments &&
      hasDocumentsToAccept &&
      router.pathname !== AcceptanceDocumentPath.termsUpdate()
    ) {
      void router.push(AcceptanceDocumentPath.termsUpdate());
    } else if (
      currentUser &&
      (!currentUser.needAcceptDocuments || !hasDocumentsToAccept) &&
      router.pathname === AcceptanceDocumentPath.termsUpdate()
    ) {
      void router.push(MainPath.index());
    }
  }, [currentUser, router]);
}
